import { cn } from '@utils';

type FilterChipVariant = 'system' | 'primary';

export interface FilterChipProps {
	label: string;
	isActive: boolean;
	onClick: () => void;
	variant?: FilterChipVariant;
	className?: string;
	'data-testid'?: string;
	'aria-pressed'?: boolean;
}

const baseStyles =
	'px-4 py-2 border-none rounded-full text-sm font-semibold cursor-pointer transition-all duration-200 ease-out focus:outline-hidden';

const variantStyles: Record<FilterChipVariant, { active: string; inactive: string }> = {
	system: {
		active: 'bg-info text-white shadow-md shadow-info/30 hover:bg-info',
		inactive: 'bg-bgPrimary text-secondary hover:bg-primary/10 hover:text-textBlack',
	},
	primary: {
		active: 'bg-primary text-white shadow-md shadow-primary/30 hover:bg-primary',
		inactive: 'bg-bgPrimary text-secondary hover:bg-primary/10 hover:text-textBlack',
	},
};

export const FilterChip = ({
	label,
	isActive,
	onClick,
	variant = 'system',
	className,
	'data-testid': dataTestId,
	'aria-pressed': ariaPressed,
}: FilterChipProps) => {
	const styles = variantStyles[variant];

	return (
		<button
			type="button"
			className={cn(baseStyles, isActive ? styles.active : styles.inactive, className)}
			onClick={onClick}
			data-testid={dataTestId}
			aria-pressed={ariaPressed}
		>
			{label}
		</button>
	);
};
